import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import { Cross } from '../../utils';
import { CloseBtn, Dropdown } from './styles';

class DropdownContainer extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
    name: PropTypes.string.isRequired,
    handleCloseButtonClick: PropTypes.func,
    onClickOutside: PropTypes.func,
    noPadding: PropTypes.bool,
    noButton: PropTypes.bool,
    floatingWidth: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.dropdown = createRef();
    this.isTouch = false;
    this.state = {
      direction: null,
      value: 0,
    }
  }

  componentDidMount() {
    const { dropdown: { current } } = this;
    const dropdownRect = current.getBoundingClientRect();
    const windowWidth = window.innerWidth;
    let overflowDelta;

    if (dropdownRect.left < 0) {
      overflowDelta = {
        direction: 'right',
        value: dropdownRect.left,
      };
    } else if (dropdownRect.right > windowWidth) {
      overflowDelta = {
        direction: 'left',
        value: windowWidth - dropdownRect.right,
      };
    }

    this.setState({...overflowDelta});

    document.addEventListener('click', this.handleClick);
    document.addEventListener('touchend', this.handleClick);
  };

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick);
    document.removeEventListener('touchend', this.handleClick);
  }

  handleClick = evt => {
    if (evt.type === 'touchend') this.isTouch = true;
    if (evt.type === 'click' && this.isTouch) return;
    const { onClickOutside, name } = this.props;
    const el = this.dropdown.current;
    const { y: dropdownY, x: dropDownX, height: dropDownHeight, width: dropDownWidth } = el.getBoundingClientRect();
    let contains;
    if(evt.type === 'touchend') {
      const { y: targetY, x: targetX } = evt.target.getBoundingClientRect();
      contains = targetY > dropdownY && targetY < (dropdownY + dropDownHeight) && targetX > dropDownX && targetX < (dropDownX + dropDownWidth);
    } else {
      const { y: targetY, x: targetX } = evt;
      contains = targetY > dropdownY && targetY < (dropdownY + dropDownHeight) && targetX > dropDownX && targetX < (dropDownX + dropDownWidth);
    }

    if (el && !contains && onClickOutside) onClickOutside(name);
  };

  render() {
    const { direction, value } = this.state;
    const { children, name, handleCloseButtonClick, noPadding, noButton, floatingWidth } = this.props;
    return (
      <Dropdown noPadding={noPadding} ref={this.dropdown} style={{ [direction || 'left']: value || 0 }} data-dropdown noButton={noButton} floatingWidth={floatingWidth}>
        {children}
        {noButton ? null : <CloseBtn type="button" name={name} onClick={handleCloseButtonClick}><Cross width={16} height={16} /></CloseBtn>}
      </Dropdown>
    )
  }
}

export default DropdownContainer;
